module.exports = __webpack_public_path__ + "static/media/illustration-feedback-reconhecimento.9aba91da.svg";